import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withQueryResults from 'components/shared/withQueryResults'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withState from './withState'
import withEventHandlers from './withEventHandlers'

// presentational components
import UI from './UI'

const withNewCamperForm = options => {
  const { redirect, onSuccess } = options

  const withNewCamperFormResults = withFormResults({
    mutation: 'createCamper',
    field: 'camper',
    successMessage: 'Camper added',
    onSuccess,
    redirect
  })

  return compose(
    withErrorBoundary,
    withRedux,
    withQueryResults,
    withQuery,
    withNewCamperFormResults,
    withMutation,
    withState,
    withEventHandlers
  )
}

// in account manager, redirect to overview
export default withNewCamperForm({ redirect: '/' })(UI)

// for registration, redirect to camper form
export { withNewCamperForm }
